export function paymentSelectionDisabledReason(row, { busy = false, loading = false } = {}) {
  if (loading || busy) return '';
  if (row.canIssueBill) return '';
  if (row.status === 'billing' || row.status === 'paid') return '';
  const remaining = Number(row.currentRemainingAmount);
  if (row.currentRemainingAmount !== null && row.currentRemainingAmount !== undefined && Number.isFinite(remaining) && remaining <= 0) {
    return '';
  }
  if (['untouched', 'retry'].includes(row.status) && Number.isFinite(remaining) && remaining > 0) {
    return '발송 중 문제가 생겼습니다. 개발자에게 문의해주세요.';
  }
  return '';
}
